import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Header = styled.div`
  margin: 0 auto 30px;
  max-width: 1024px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AgentLogo = styled.img`
  max-height: 60px;
  margin-right: 15px;
`;

export const FooterLink = styled.a`
  display: flex;
  margin: 20px auto;
  align-items: center;
  font-size: 16px;
  color: ${({ theme }) => theme.white};

  &:hover {
    text-decoration: underline;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;
  }
`;

export const AgentHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

export const Icon = styled.div`
  border: solid 1px ${({ theme }) => theme.lightGrey};
  border-radius: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @meida (${mobileXXLargeMax}) {
    margin-bottom: 10px;
  }
`;
